import GetSafetyAnchorPointRequestModelBase from '../_generated/modelBases/get-safety-anchor-point-request-model-base';

export default class GetSafetyAnchorPointRequestModel extends GetSafetyAnchorPointRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
